import React, { useState, useEffect } from "react";
import {
  CardBody,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  Card,
  Button,
  ModalBody,
  Modal,
  ModalFooter,
} from "reactstrap";
import { NavLink, useHistory, useParams } from "react-router-dom";
import classnames from "classnames";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

import BasicInformation from "./../jobrequisition/basicInformationScreen";
import FileUpload from "./fileUpload";
import ReqSkills from "./skills/reqskills";
import { toast } from "react-toastify";
import { ENV, isNullOrEmpty } from "../../../../config/ENV";
import { JobService } from "../../../../services/JobService";
import AddNotes from "./addnotes";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import ViewCandidate from "./candidatesview/viewcandidate";

const AddReqScreen = (props) => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState("basicInfo");
  const [modalarchive, setModalarchive] = useState(false);
  const [modalactivate, setModalactivate] = useState(false);
  const [modalcopy, setModalcopy] = useState(false);
  const [modalDraft, setModalDraft] = useState(false);
  const [modalHmsSent, setModalHmsSent] = useState(false);
  const [modalOnHold, setModalOnHold] = useState(false);
  const [modalFilled, setModalFilled] = useState(false);
  const [modellost, setModelLost] = useState(false);
  const [modelCancelled, setModelCancelled] = useState(false);
  const [jobid, setJobId] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [publicTitle, setPublicTitle] = useState("");
  const [talentAdvisor, setTalentAdvisor] = useState("");
  const [jobAccount, setJobAccount] = useState("");
  const [jobstatus, setJobStatus] = useState("");
  const [candidateJobDetails, setCandidateJobDetails] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [hmsId, setHmsId] = useState("");
  const [selectedJobStatus, setSelectedJobStatus] = useState("OPPORTUNITY");
  const query = new URLSearchParams(window.location.search);
  const tab = query.get("t");
  const screen = query.get("screen");
  var { id } = useParams();
  const jobId=id;
  

  const handleCallBack = (childData, jobId) => {
    if (id == 0) {
      id = jobId;
    }
    if (childData === "fileUpload") {
      history.push(`/addrequest/${id}?t=fileupload`);
      setActiveTab("fileUpload");
    } else if (childData === "skills") {
      history.push(`/addrequest/${id}?t=skills`);
      setActiveTab("skills");
    } else if (childData === "addnotes") {
      history.push(`/addrequest/${id}?t=addnotes`);
      setActiveTab("addnotes");
    } else {
      history.push(`/addrequest/${id}?t=basicInfo`);
      setActiveTab("basicInfo");
    }
  };

  const handlefileupload = () => {
    if (window.localStorage.getItem("requestId") !== "") {
      setActiveTab("fileUpload");
    } else {
      toast.error("Please fill basic information");
      return;
    }
  };

  const handleskillsscreen = () => { 
    if (id !== "") {
      setActiveTab("skills");
    } else {
      toast.error("Please fill basic information");
      return;
    }
  };
  const handleNotesTab = () => {
    if (window.localStorage.getItem("requestId") !== "") {
      setActiveTab("addnotes");
      return;
    }
    toast.error("Please fill basic information");
    return;
  };

  useEffect(() => {

    if (
      window.localStorage.getItem("currentStatus") !== "OPPORTUNITY" ||
      window.localStorage.getItem("currentStatus") !== "DRAFT" ||
      window.localStorage.getItem("currentStatus") !== "ACTIVE"
    ) {   

      if (tab === "basicinfo") {
        setActiveTab("basicInfo");
      } else if (tab === "fileupload") {
        setActiveTab("fileUpload");
      } else if (tab === "skills") {
        setActiveTab("skills");
      } else if (tab === "notes") {
        setActiveTab("addnotes");
      } else if (tab === "candidates") {
        setActiveTab("viewcand");
      }
    }
      if (tab === "notes") {
        setActiveTab("addnotes");
      }
    
  }, []);

  const copyHMSLink = () => {
    const el = document.createElement("input");
    el.value =
      ENV.hmsLinkUrl + "sd?p=hms&id=" + hmsId;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    window.open(ENV.hmsLinkUrl + "sd?p=hms&id=" + hmsId);
  };

  const goBack = () => {
    history.push("/requests");
  };

  const handlecopy = () => {
    setModalcopy(true);
  };

  const handleDraft = () => {
    setModalDraft(true);
  };

  const copyJobRequest = () => {
    JobService.copyJobRequest(jobId).then((response) => {
      if (response.message != null) {
        if (response.data.error_message !== "") {
        }
      } else {
        toast.success("Job copied successfully.");
        window.localStorage.setItem("requestId", response.data.id);

        props.history.push("/requests");
      }
    });
  };

  const handleactive = () => {
    setModalactivate(true);
  };

  const activateRequest = () => {
    JobService.activateRequestService(jobId).then((response) => {
      if (response.message != null) {
        if (response.data.error_message !== "") {
        }
      } else {
        if (response.data !== null) {
          toast.success("Your job req is activated successfully");
          // props.history.push("/requests");
          setModalactivate(false);
          window.location.reload(false);
        }
      }
    });
  };

  const handlearchive = () => {
    setModalarchive(true);
  };

  const handleCancelled = () => {
    setModelCancelled(true);
  };

  const closeRequest = () => {
    JobService.closeRequestService(jobId).then((response) => {
      if (response.message != null) {
        if (response.data.error_message !== "") {
        }
      } else {
        if (response.data !== null) {
          toast.success("Your job req is closed successfully");
          // props.history.push("/requests");
          setModalactivate(false);
          window.location.reload(false);
        }
      }
    });
    setModalarchive(false);
  };

  const DraftRequest = () => {
    JobService.draftRequest(jobId).then((response) => {
      if (response.message != null) {
        if (response.data.error_message !== "") {
        }
      } else {
        if (response.data !== null) {
          toast.success("Your job req is drafted successfully");
          // props.history.push("/requests");
          handleCallBack();

          setModalactivate(false);
          window.location.reload(false);
        }
      }
    });
    setModalDraft(false);
  };

  const handleHmsSent = () => {
    setModalHmsSent(true);
  };

  const SentRequestToHms = () => {
    JobService.hmsSentRequest(jobId).then((response) => {
      if (response.message != null) {
        if (response.data.error_message !== "") {
        }
      } else {
        if (response.data !== null) {
          toast.success("Your job req is hms sent successfully");
          // props.history.push("/requests");
          setModalactivate(false);
          window.location.reload(false);
        }
      }
    });
    setModalHmsSent(false);
  };

  const handleFilled = () => {
    setModalFilled(true);
  };

  const filledRequest = () => {
    JobService.hmsFilled(jobId).then((response) => {
      if (response.message != null) {
        if (response.data.error_message !== "") {
        }
      } else {
        if (response.data !== null) {
          toast.success("Your job req is onhold successfully");
          // props.history.push("/requests");
          setModalactivate(false);
          window.location.reload(false);
        }
      }
    });
    setModalFilled(false);
  };

  const handleLost = () => {
    setModelLost(true);
  };

  const lostRequest = () => {
    JobService.lostRequest(jobId).then((response) => {
      if (response.message != null) {
        if (response.data.error_message !== "") {
        }
      } else {
        if (response.data !== null) {
          toast.success("Your job req is lost successfully");
          // props.history.push("/requests");
          setModalactivate(false);
          window.location.reload(false);
        }
      }
    });
    setModelLost(false);
  };

  const cancelledRequest = () => {
    JobService.cancelledRequest(jobId).then((response) => {
      if (response.message != null) {
        if (response.data.error_message !== "") {
        }
      } else {
        if (response.data !== null) {
          toast.success("Your job req is cancelled successfully");
          setModalactivate(false);
          window.location.reload(false);
        }
      }
    });
    setModelCancelled(false);
  };

  const handleOnHold = () => {
    setModalOnHold(true);
  };

  const onHoldRequest = () => {
    JobService.hmsOnhold(jobId).then((response) => {
      if (response.message != null) {
        if (response.data.error_message !== "") {
        }
      } else {
        if (response.data !== null) {
          toast.success("Your job req is onholdsuccessfully");
          // props.history.push("/requests");
          setModalactivate(false);
          window.location.reload(false);
        }
      }
    });
    setModalOnHold(false);
  };

  const copyLPUrl = () => {
    var templateUrl =
      ENV.candidate_web_url +
      "?p=jobreq&jobId=" +
      window.localStorage.getItem("requestId");
    if (!isNullOrEmpty(window.localStorage.getItem("requestId"))) {
      // let jobId = window.localStorage.getItem("requestId");
      JobService.getJob(jobId).then((response) => {
        let landingPageTemplate = "";
        let landingPageTemplateFields = [];
        try {
          if (response.message != null) {
            if (response.data.error_message !== "") {
            }
          } else {
            if (response.data != null) {
              var jobDetails = response.data;
              // let jobId='';

              // if (!isNullOrEmpty(jobDetails.jobId)) {
              //   jobId= jobDetails.jobId
              // }
              if (!isNullOrEmpty(jobDetails.landingPageTemplate)) {
                landingPageTemplate = jobDetails.landingPageTemplate;
                templateUrl =
                  templateUrl + "&templateName=" + landingPageTemplate;
              }

              if (jobDetails.landingPageFields !== null) {
                landingPageTemplateFields = jobDetails.landingPageFields;
                if (landingPageTemplateFields.length > 0) {
                  landingPageTemplateFields.forEach((template) => {
                    let name = template.name;
                    let value = template.value;
                    templateUrl = templateUrl + "&" + name + "=" + value;
                  });
                }
              }
              displayTemplateUrl(templateUrl);
            } else {
              displayTemplateUrl(templateUrl);
            }
          }
        } catch (err) {
          console.log("message" + JSON.stringify(err.message));
          displayTemplateUrl(templateUrl);
        }
      });
    } else {
      displayTemplateUrl(templateUrl);
    }
  };

  const displayTemplateUrl = (templateUrl) => {
    const el = document.createElement("input");
    el.value = encodeURI(templateUrl);
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    window.open(encodeURI(templateUrl));
  };

  const showStatusDropdown = () => {
    let flag = window.localStorage.getItem("add");
    if (flag === "add") return false;
    return true;
  };


  const showOpportunityButton = () => {
    let status = selectedJobStatus;
    if (   
      status !== "OPPORTUNITY")
      return true;
    else return false;
  };

  const showActivateButton = () => {
    let status = selectedJobStatus;
    let flag = window.localStorage.getItem("add");
    if (
      status !== "ACTIVE" ||
      (status === "LOST" && flag !== "add")
    )
      return true;
    else return false;
  };

  const showHmsSentButton = () => {
    let status = selectedJobStatus;
   if (   
      status !== "HMS_SENT") return true;
    else return false;
  };

  const showOnHoldButton = () => {
    let status = selectedJobStatus;
    if (status !== "ONHOLD") return true;
    else return false;
  };

  const showFilledButton = () => {
    let status = selectedJobStatus;
    if (status !== "FILLED")
      return true;
    else return false;
  };

  const showLostButton = () => {
    let status = selectedJobStatus;
    if (status !== "LOST")
      return true;
    else return false;
  };

  const showCancelledButton = () => {
    let status = selectedJobStatus;
    let flag = window.localStorage.getItem("add");
    if (
      status !== "CANCELLED" ||
      (status === "ONHOLD" && flag !== "add")
    )
      return true;
    else return false;
  };

  const showHmsButton = () => {
    let flag = window.localStorage.getItem("add");
    let status = selectedJobStatus;
    if (status !== "OPPORTUNITY" && status !== "DRAFT" && flag !== "add")
      return true;
    else return false;
  };

  const showLPButton = () => {
    var reqId = window.localStorage.getItem("requestId");
    if (reqId === null || reqId === "") {
      return false;
    }
    return true;
  };

  const showCandidateTab = () => {
    if (
     selectedJobStatus !== "OPPORTUNITY" &&
      selectedJobStatus !== "add"
    )
      return true;
    else return false;
  };

  const showArchiveButton = () => {
    let status = selectedJobStatus;
    let flag = window.localStorage.getItem("add");
    if (
      status === "OPPORTUNITY" ||
      status === "ACTIVE" ||
      status === "HMS_SENT" ||
      (status === "ONHOLD" && flag !== "add")
    )
      return true;
    else return false;
  };

  

  const showCopyButton = () => {
    let flag = window.localStorage.getItem("add");

    if (flag !== "add") return true;
    else return false;
  };

  useEffect(() => {
    if (id != null) {
     getJobDetails(id);
    } else {
      setIsLoading(true);
    }
  }, []);

  const getJobDetails = (jobId) => {
    JobService.getJob(jobId).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data != null) {
            var jobDetails = response.data;

            if (jobDetails !== null || jobDetails !== " ") {
              setCandidateJobDetails(jobDetails);
              setJobAccount(jobDetails.account);
              setJobId(jobDetails.jobId);
              setJobTitle(jobDetails.jobTitle);
              setPublicTitle(jobDetails.publicTitle);
              setTalentAdvisor(jobDetails.talentAdvisor);
              setHmsId(jobDetails.hmsId)
              setJobStatus(jobDetails.jobStatus.value);
            }
            if (jobDetails.jobStatus != null) {
              setSelectedJobStatus(jobDetails.jobStatus.key);
            }
          }
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
      setIsLoading(true);
    });
  };

  const showJobDetails = () => {
    const arr = [];

    if (!isNullOrEmpty(jobid)) {
      arr.push(jobid);
    }
    if (!isNullOrEmpty(jobTitle)) {
      arr.push(jobTitle);
    }
    if (!isNullOrEmpty(publicTitle)) {
      arr.push(publicTitle);
    }
    if (!isNullOrEmpty(jobstatus)) {
      arr.push(jobstatus);
    }
    if (!isNullOrEmpty(talentAdvisor.firstName)) {
      arr.push(talentAdvisor.firstName);
    }

    if (!isNullOrEmpty(jobAccount.name)) {
      arr.push(jobAccount.name);
    }
    if (arr.length > 0) {
      return <>{arr.join(" | ")}</>;
    }
  };

  return (
    <>
      <Card>
        <Colxx className="mt-2" sm={10} style={{ padding: 0 }}>
          <div className="col">
            <div className=" ml-3 ">
              <h3 className="mt-2">
                {showJobDetails(
                  jobid,
                  jobTitle,
                  publicTitle,
                  jobstatus,
                  talentAdvisor.firstName,
                  jobAccount.name
                )}
              </h3>
            </div>
          </div>
        </Colxx>

        <CardBody>
          <div className="col-sm-12 p-0">
            <Nav
              tabs
              className="separator-tabs nav nav-tabs t-justify-content flex mb-2"
            >
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "basicInfo",
                    "nav-link": true,
                  })}
                  onClick={() => setActiveTab("basicInfo")}
                  to={`/addrequest/${id}?t=basicInfo`}
                  location={{}}
                >
                  Basic Info
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "fileUpload",
                    "nav-link": true,
                  })}
                  onClick={(e) => handlefileupload(e)}
                  to={`/addrequest/${id}?t=fileupload`}
                  location={{}}
                >
                  Documents
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "skills",
                    "nav-link": true,
                  })}
                  onClick={(e) => handleskillsscreen(e)}
                  to={`/addrequest/${id}?t=skills`}
                  location={{}}
                >
                  Skills
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === "addnotes",
                    "nav-link": true,
                  })}
                  onClick={(e) => handleNotesTab(e)}
                  to={`/addrequest/${id}?t=notes`}
                  location={{}}
                >
                  Notes
                </NavLink>
              </NavItem>
              {showCandidateTab() && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "viewcand",
                      "nav-link": true,
                    })}
                    onClick={() => setActiveTab("viewcand")}
                    // onClick={(e) => handleskillsscreen(e)}
                    to={`/addrequest/${id}?t=candidates`}
                    location={{}}
                  >
                    Candidates
                  </NavLink>
                </NavItem>
              )}

              <div className="text-right col-lg-6 p-0">
                <div className="btn-group">
                  <div className="btn-primary">
                    {showStatusDropdown() && (
                      <DropdownButton  size="sm" title="Status">
                        {/* {showDraftButton() && (
                          <Dropdown.Item onClick={handleDraft}>
                            Draft
                          </Dropdown.Item>
                        )} */}
                         {showOpportunityButton() && (
                          <Dropdown.Item onClick={handleDraft}>                            
                            Opportunity
                          </Dropdown.Item>
                        )}
                        {showActivateButton() && (
                          <Dropdown.Item onClick={handleactive}>
                            Req Live
                          </Dropdown.Item>
                        )}
                        {showHmsSentButton() && (
                          <Dropdown.Item onClick={handleHmsSent}>
                            HMS Active
                          </Dropdown.Item>
                        )}
                        {showOnHoldButton() && (
                          <Dropdown.Item onClick={handleOnHold}>
                            On Hold
                          </Dropdown.Item>
                        )}
                        {showFilledButton() && (
                          <Dropdown.Item onClick={handleFilled}>
                            Closed / Won
                          </Dropdown.Item>
                        )}
                        {showLostButton() && (
                          <Dropdown.Item onClick={handleLost}>
                             Closed / Lost
                          </Dropdown.Item>
                        )}
                        {/* {showArchiveButton() && (
                          <Dropdown.Item onClick={handlearchive}>
                            Closed
                          </Dropdown.Item>
                        )} */}
                         {showCancelledButton() && (
                          <Dropdown.Item onClick={handleCancelled}>
                            Cancelled
                          </Dropdown.Item>
                        )}
                      </DropdownButton>
                    )}
                  </div>
                  {showCopyButton() && (
                    <Button
                      color="primary"
                      outline
                      size="sm"
                      onClick={handlecopy}
                    >
                      {" "}
                      Copy{" "}
                    </Button>
                  )}
                  {showHmsButton() && (
                    <Button
                      color="primary"
                      size="sm"
                      outline
                      onClick={copyHMSLink}
                    >
                      {" "}
                      HMS Link{" "}
                    </Button>
                  )}
                  {showLPButton() && (
                    <Button
                      color="primary"
                      size="sm"
                      outline
                      onClick={copyLPUrl}
                    >
                      {" "}
                      LP Link{" "}
                    </Button>
                  )}
                  <Button color="primary" outline size="sm" onClick={goBack}>
                    {" "}
                    Back{" "}
                  </Button>
                </div>
              </div>
            </Nav>
          </div>
          <div></div>

          {isLoading && (
            <TabContent activeTab={activeTab}>
              <TabPane tabId="basicInfo" disabled>
                <BasicInformation
                  parentCallback={handleCallBack}
                  jobDetails={candidateJobDetails}
                />
              </TabPane>

              <TabPane tabId="fileUpload">
                <FileUpload
                  parentCallback={handleCallBack}
                  jobDetails={candidateJobDetails}
                />
              </TabPane>

              <TabPane tabId="skills">
                <ReqSkills
                  parentCallback={handleCallBack}
                  jobDetails={candidateJobDetails}
                />
              </TabPane>
              <TabPane tabId="addnotes">
                <AddNotes
                  parentCallback={handleCallBack}
                  jobDetails={candidateJobDetails}
                />
              </TabPane>

              <TabPane tabId="viewcand">
                <ViewCandidate
                  parentCallback={handleCallBack}
                  jobDetails={candidateJobDetails}
                />
              </TabPane>
            </TabContent>
          )}
        </CardBody>
      </Card>

      <Modal
        isOpen={modalarchive}
        toggle={() => setModalarchive(!modalarchive)}
      >
        <ModalBody>
          Do you want to change the status to <strong>Archive</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalarchive(false)}
          >
            No
          </Button>
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => {
              closeRequest();
            }}
          >
            Yes
          </Button>{" "}
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={modalactivate}
        toggle={() => setModalactivate(!modalactivate)}
      >
        <ModalBody>
          Do you want to change the status to <strong>Req Live</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalactivate(false)}
          >
            No
          </Button>
          <Button color="primary" size="sm" outline onClick={activateRequest}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalcopy} toggle={() => setModalcopy(!modalcopy)}>
        <ModalBody>
          Do you want to <strong>Copy Job Requisition</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalcopy(false)}
          >
            No
          </Button>
          <Button color="primary" size="sm" outline onClick={copyJobRequest}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalDraft} toggle={() => setModalDraft(!modalDraft)}>
        <ModalBody>
          Do you want to change the status to <strong>Opportunity</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary "
            size="sm"
            outline
            onClick={() => setModalDraft(false)}
          >
            No
          </Button>
          <Button color="primary" size="sm" outline onClick={DraftRequest}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalHmsSent} toggle={() => setModalHmsSent(!modalDraft)}>
        <ModalBody>
          Do you want to change the status to <strong>HMS Active</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalHmsSent(false)}
          >
            No
          </Button>
          <Button color="primary" size="sm" outline onClick={SentRequestToHms}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalFilled} toggle={() => setModalFilled(!modalFilled)}>
        <ModalBody>
          Do you want to change the status to <strong>Closed / Won</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalFilled(false)}
          >
            No
          </Button>
          <Button color="primary" size="sm" outline onClick={filledRequest}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalOnHold} toggle={() => setModalOnHold(!modalOnHold)}>
        <ModalBody>
          Do you want to change the status to <strong>On Hold</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalOnHold(false)}
          >
            No
          </Button>
          <Button color="primary" size="sm" outline onClick={onHoldRequest}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modellost} toggle={() => setModelLost(!modellost)}>
        <ModalBody>
          Do you want to change the status to <strong>Closed / Lost</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModelLost(false)}
          >
            No
          </Button>
          <Button color="primary" size="sm" outline onClick={lostRequest}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modelCancelled} toggle={() => setModelCancelled(!modelCancelled)}>
        <ModalBody>
          Do you want to change the status to <strong>Cancelled</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModelCancelled(false)}
          >
            No
          </Button>
          <Button color="primary" size="sm" outline onClick={cancelledRequest}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AddReqScreen;
